import React, {useEffect, useState} from 'react'
import Mapa from './Mapa' 
import axios from 'axios';
import qs from 'qs';
import { authUser } from '../../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../../context/AuthContext'
import {GeneralesContext} from '../../context/GeneralesContext'
import {Box, Button, LinearProgress,FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../../funciones/ClienteAxios';
import {ordenMapBx} from '../../MapaEdo/OrdenxMapBox'
const MapaDto =()=>{
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ; 
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0; 
    const Dispvo =localStorage.getItem('Dispvo') ;       
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs' 
    const[lista, setLista]= useState([])
    const [espera,setEspera]= useState(false);
    const[bandera, setBandera]= useState(true)
    const [contador, setContador] = useState(1);
    const[listDistrito,setListDistrito]= useState([]);  
    const[listPoliDto, setListPoliDto]= useState([]);  
    const[listGeoJDto, setListGeoJDto]= useState([]); 
    const[listColOtb, setListColOtb]= useState([]); 
    const[listMarcador, setListMarcador]= useState([]);   
    const[listNumOtb, setListNumOtb]= useState([]);   
    const[distrito, setDistrito]= useState([]);  
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);    

        useEffect(()=>{             
            const autenticado = authUser();
            if(!autenticado){
                localStorage.clear();
                history.push("/");
                guardarUsuario([])
            }
            else
            {   const usu= localStorage.getItem('UsuarioNom');                 
                if (usuario.length===0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                                               
                }                      
                
                getListGeoJDto()
                guardarGenerales({...generales,Titulo:'Mapa Distrito'})      
                    
            }
            
            return ()=> {
                source.cancel();
            }      
        //la siguiente linea puede generar errores o no en el useEffect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    function getListDto()  {            
        const auxU= `lugar/municipio/distrito`;                            
        const dataInfo = qs.stringify({                
            Usuario:auxId,     
            Estado: 2,  ip:"127.0.0.0",                      
            idDispositivo:auxDispV,
            });
                    
        function respuesta (auxiliar) 
        {   if (auxiliar[0].Id !== -1) 
            {   let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                });                                                 
                setListDistrito(listNvo) 
            }                                                            
        }
        llamadaApiToken(dataInfo, auxU, respuesta, ErrorGeneral,  history, source);
    };

    const getListGeoJDto = () => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Estado:2, idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/comuna/mapa";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxCol=[], auxArr2=[], auxArr3=[], auxListOtb=[], listCol=[]                            
 
                auxCol=["match",["get", "IdDto"]]
                auxiliar[0].distrito.forEach((element)=>{
                    let nvoArr=[]
                    if (element.gps) 
                    {   element.gps.forEach((poligono)=>{
                            nvoArr.push([poligono.Ln, poligono.Lt])
                        })     
                        
                        auxArr2.push({ 
                            "id":element.DtId,
                            'type': 'Feature',
                            "properties":{
                                "IdDto":element.DtId, 
                                "colDto":element.DtCol
                            },
                            "nomOtb":element.DtNom,                                
                            'geometry': {                        
                                'type': 'MultiPolygon',                         
                                'coordinates': [[nvoArr]]
                            }
                        })
                        //auxCol.push(element.Id)      
                        //auxCol.push(element.DtCol)  
                        ordenMapBx(listCol, element.DtId, element.DtCol) 
                        auxListOtb.push({...element, coordinates:[element.DtLon, element.DtLat]})         
                    }
                    
                })    
                listCol.forEach((elemento)=>{
                    auxCol.push(elemento.pos)
                    auxCol.push(elemento.auxColor)
                    //cuenta=cuenta+elemento.pos.length
                })                 
                auxCol.push('#cedded')                   
                    
                auxArr3={"type": "FeatureCollection",
                    "name": "Cochabamba",
                    "features":auxArr2}
             
                setListNumOtb(auxListOtb)
                setListColOtb(auxCol)                                                   
                setListGeoJDto(auxArr3)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListMarcador = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/recinto/dto";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]              
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push({coordinates:[poligono.ln, poligono.lt], original:poligono})                  
                })                
                setListMarcador(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

 
    return(
    <Box display={"flex"} flexDirection={"column"}>
  
        {!espera && listColOtb.length!==0 && listNumOtb.length!==0 && listGeoJDto.length!==0 ? 
            <Mapa lista={listPoliDto} setLista={setLista} setActualiza={()=>setBandera(!bandera)} 
                contador={contador} setContador={setContador} listMarcador={listMarcador} 
                listGeoJDto={listGeoJDto} listColOtb={listColOtb} listNumOtb={listNumOtb}
            />
        : espera ?<Box mt={5}><LinearProgress/></Box>:null}
      
    </Box>)
}

export default MapaDto